module.exports = __webpack_public_path__ + "static/media/respiratory-system-diseases-icon.8ece2813.svg";